import React from 'react';
import './Backdrop.css';

export default function backdrop(props) {
	if (props.open) return <div className="backdrop"></div>;
	return null;
}
